export const PUBLICATIONS_PAGE = {
  title: "Publications municipales",
  eyebrow: "Informations & documents",
  description:
    "Retrouvez les bulletins municipaux, guides pratiques, plaquettes d’information et documents mis à disposition par la commune.",
  heroImageUrl:
    "https://www.esbly.fr/wp-content/uploads/2022/08/Publications-municipales-1200x630-1.png",
  crumbs: [
    { label: "Accueil", href: "/" },
    { label: "Ma Ville" },
    { label: "Publications" },
  ],
};